export default {
    methods: {
        getTranslation(value) {
            if (!value) {
                return null;
            }
            let entries = Object.values(value);
            if (entries.length === 0) {
                return null;
            }

            return entries[0];
        },
        generatedId() {
            return "y" + Math.random().toString(16).slice(2);
        }
    }
};
